import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusinessTimeInfo } from '@app/model/business-time-info';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';

@Component({
  selector: 'app-working-details',
  templateUrl: './working-details.component.html',
  styleUrls: ['./working-details.component.scss']
})
export class WorkingDetailsComponent implements OnInit {
  businessTime: any;
  userInfoId: any;
  //For Alert
  alert: any;

  constructor(private businessInfoService: BusinessDetailsService,
    private route: ActivatedRoute
  ) {
    this.businessTime = new BusinessTimeInfo();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
    })
    
    if(this.userInfoId){
      this.getWorkingInfoById();
    }
  }

  getWorkingInfoById(): void {
    this.businessInfoService.getTimeInfoByUUId(this.userInfoId)
      .subscribe({
        next: (res:any) => {
          this.businessTime = res as BusinessTimeInfo;  
          if (res.success !== 0) {
            this.businessTime.dt_Monday = this.businessTime.data[0].dt_Monday;
            this.businessTime.dt_Tuesday = this.businessTime.data[0].dt_Tuesday;
            this.businessTime.dt_Wednesday = this.businessTime.data[0].dt_Wednesday;
            this.businessTime.dt_Thursday = this.businessTime.data[0].dt_Thursday;
            this.businessTime.dt_Friday = this.businessTime.data[0].dt_Friday;
            this.businessTime.dt_Saturday = this.businessTime.data[0].dt_Saturday;
            this.businessTime.dt_Sunday = this.businessTime.data[0].dt_Sunday;
          } else {
            this.businessTime.dt_Monday = '10AM - 6PM';
            this.businessTime.dt_Tuesday = '10AM - 6PM';
            this.businessTime.dt_Wednesday = '10AM - 6PM';
            this.businessTime.dt_Thursday = '10AM - 6PM';
            this.businessTime.dt_Friday = '10AM - 6PM';
            this.businessTime.dt_Saturday = '10AM - 6PM';
            this.businessTime.dt_Sunday = 'Close';
          }
        },
        error: (err: any) => {
          this.alert = false;
        }
      }
      )
  }

}
